export default __webpack_public_path__ + "media/images/fencing-icon-6fbdf0919469578c16a44c470e568a60.svg";